// Version : 0.0.1
// Author : SATHISH
// LastEdit : SATHISH
// MODFIED DATE:11-10-2025
//Last ADD :CODE REVIEW CHANGES AND ADD VERSION
const groupReportTypes = {
	/***************** GET GROUP REPORT START *************** */
	GET_GROUP_REPORT_START: 'get_group_report_start',
	GET_GROUP_REPORT_SUCCESS: 'get_group_report_success',
	GET_GROUP_REPORT_FAILURE: 'get_group_report_failure',
	GET_GROUP_REPORT_RESPONSE_RESET_START: 'get_group_report_reset_start',
	GET_GROUP_REPORT_RESPONSE_RESET_CHANGED: 'get_group_report_response_changed',
	/***************** GET GROUP REPORT END *************** */
};
export default groupReportTypes;
